import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

export default function SoftProductFields({ products }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  return (
    <div className="mb-4">
      <h5 className="font-semibold">
        {t('projectProposal.researchResult.productAndResearchResultDes.softProduct.label')}
      </h5>
      <p className="font-italic">
        {t('projectProposal.researchResult.productAndResearchResultDes.softProduct.note')}
      </p>

      <div className="grid">
        <div className="col-12">
          <div
            className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines p-datatable-gridlines"
            data-scrollselectors=".p-datatable-wrapper"
          >
            <div className="p-datatable-wrapper">
              <table className="p-datatable-table">
                <thead className="p-datatable-thead">
                  <tr>
                    <th style={{ textAlign: 'center' }}>
                      <span className="p-column-title">
                        {t(
                          'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.order'
                        )}
                      </span>
                    </th>
                    <th style={{ minWidth: '6rem', textAlign: 'center' }}>
                      <span className="p-column-title">
                        {t(
                          'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.productName'
                        )}
                      </span>
                    </th>
                    <th style={{ minWidth: '6rem', textAlign: 'center' }}>
                      <span className="p-column-title">
                        {t(
                          'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.evaluativeCriteria'
                        )}
                      </span>
                    </th>
                    <th style={{ minWidth: '6rem', textAlign: 'center' }}>
                      <span className="p-column-title">
                        {t(
                          'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.note'
                        )}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody className="p-datatable-tbody">
                  {products?.map((product, index) => (
                    <tr key={product?.id ?? index}>
                      <td style={{ textAlign: 'center' }}>{index + 1}</td>
                      <td style={{ minWidth: '6rem' }}>{product?.name}</td>
                      <td style={{ minWidth: '6rem' }}>{product?.evaluativeCriteria}</td>
                      <td style={{ minWidth: '6rem' }}>{product?.note}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SoftProductFields.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products: PropTypes.array.isRequired,
};
